import type { Layout } from './layout';
import { formatClock } from './renderer';

export interface HudData {
  sessionPieces: number;
  sessionRate: number;
  sessionFinessePercent: number;
  sessionFaults: number;
  level: number;
  score: number;
  puzzlePieces: number;
  puzzleFinessePercent: number;
  puzzleFaults: number;
  elapsedMs: number;
  solved: boolean;
}

export function updateHud(layout: Layout, data: HudData): void {
  layout.statPieces.textContent = String(data.sessionPieces);
  layout.statPiecesSub.textContent = `, ${data.sessionRate.toFixed(2)}/s`;

  layout.statFinesse.textContent = String(data.sessionPieces);
  layout.statFinesseSub.textContent = `, ${data.sessionFinessePercent.toFixed(2)}%, ${data.sessionFaults}F`;

  layout.statLevel.textContent = String(data.level);
  layout.statScore.textContent = String(data.score);

  layout.puzzleFinesse.textContent = String(data.puzzlePieces);
  layout.puzzleFinesseSub.textContent = `, ${data.puzzleFinessePercent.toFixed(2)}%, ${data.puzzleFaults} FAULTS`;

  layout.timerEl.textContent = formatClock(data.elapsedMs);
  layout.timerEl.classList.toggle('solved', data.solved);
}

interface ToastHost extends HTMLElement {
  _toastTimer?: number;
}

export function showToast(layout: Layout, message: string, durationMs = 1600): void {
  const toast = layout.toast as ToastHost;
  toast.textContent = message;
  toast.hidden = false;
  toast.classList.add('visible');
  if (toast._toastTimer !== undefined) window.clearTimeout(toast._toastTimer);
  toast._toastTimer = window.setTimeout(() => {
    toast.classList.remove('visible');
    toast.hidden = true;
  }, durationMs);
}
